
// 复制对象
export function $copyObj (obj) {
  if (typeof obj === 'object') {
    return JSON.parse(JSON.stringify(obj))
  } else {
    return obj
  }
}

// 格式化价格
export function formatPrice (val) {
  if (isNaN(val)) {
    return val
  }
  val = (Math.floor(val * 100) / 100).toFixed(2)
  return val
}

export function formatNum (val) {
  val = val + ''
  let arr = val.split('')
  arr.reverse()

  let newArr = []
  for (var i in arr) {
    newArr.push(arr[i])
    if ((i + 1) % 3 === 0 && i < (arr.length - 1)) {
      newArr.push(',')
    }
  }
  newArr.reverse()
  return newArr.join('')
}

/**
 * 查询url中带的参数
 */
export function getQueryVariable (variable) {
  var query = window.location.search.substring(1)
  var vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0] == variable) {
      return pair[1]
    }
  }
  return ''
}



// WEBPACK FOOTER //
// ./src/utils/comm.js